export default __webpack_public_path__ + "static/media/youwin.d98792e2.png";